import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ErrorMessages from '../../../SharedModule/MessageHandlers/ErrorMessages';
// import SuccessMessage from '../../../SharedModule/MessageHandlers/SuccessMessage';
import Spinner from '../../../SharedModule/Spinner/Spinner';
import * as AppConstants from '../../../SharedModule/Utils/AppConstants';
import { GenerateOtp, GenerateOtpResponse } from '../Store/Actions/MFACodeActions'
import EmailIcon from '@material-ui/icons/Email';
import SmsIcon from '@material-ui/icons/Sms';
import { SYSTEM_ERROR, EMAIL_MOBILE_ERROR } from '../../../SharedModule/Utils/AppConstants'
import * as serviceEndPoint from '../../../SharedModule/Service/service';
import axios from 'axios';

const SendMFACode = (props) => {

  const dispatch = useDispatch();
  const otpResponse = useSelector(state => state.mfaCodeReducers.otpResponse)
  const mfaData = props.location.state && props.location.state;
  const fromPath = props.location.state && props.location.state.fromPath;
  const userId = props.location.state && props.location.state.userID;
  const mfaValue = props.location.state && props.location.state.mfaValue;

  useEffect(() => {
    if (!fromPath) {
      AppConstants.backToLogin(props);
    }
  }, [fromPath])

  const maskEmail = (email) => {
    if (email) {
      const [name, domain] = email.split('@')
      const { length: len } = name;
      const maskedName = name[0] + 'X'.repeat(len - 2) + name[len - 1]
      return maskedName + '@' + domain
    }
    return null
  }

  function formatPhoneNumber(phoneNumberString) {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', [...match[2][0]], 'XX) ', 'X', [[...match[3][1]]], 'X', '-', 'XXX',[...match[4][3]]].join('');
    }
    return null;
  }

  // eslint-disable-next-line no-unused-vars
  const [data, setData] = React.useState({
    email: (mfaValue === 'E' || mfaValue === 'ES') ? maskEmail(mfaData && mfaData.email) : null,
    mobileNumber: (mfaValue === 'S' || mfaValue === 'ES') ? formatPhoneNumber(mfaData && mfaData.mobileNumber) : null
  });
  const email_mobile_text = data.email && data.mobileNumber ? 'email and phone number' :
    data.email ? 'email' : data.mobileNumber ? 'phone number' : '';
  const [errorMessages, setErrorMessages] = React.useState([]);
  // const [successMessages, setSuccessMessages] = React.useState([]);
  const [spinnerLoader, setSpinnerLoader] = React.useState(false);
  const [isCodeGenerated, setIsCodeGenerated] = React.useState(false);
  const [isRadioButtonSelected, setIsRadioButtonSelected] = React.useState('');
  // const isAuthorisedUser = sessionStorage.getItem('authToken');
  useEffect(() => {
    if (otpResponse && otpResponse.status === 'Generated' && isCodeGenerated) {
      setSpinnerLoader(false)
      props.history.push({
        pathname: '/validateOTP',
        state: { otpResponse, isMFA: true, passwordExpiry: mfaData && mfaData.passwordExpiry, passwordExpiryRem: mfaData && mfaData.passwordExpiryRem ,
          mfaType: isRadioButtonSelected === 'email' ? 'e' : 's',
          userId : userId
          // userId
        }
      })
    }
    else if (otpResponse && (otpResponse.status === 'Technical Error'
      || otpResponse.status === 'Bad Request' || otpResponse.status === 'Failure'
      || otpResponse.systemFailure)) {
      // setErrorMessages(['We could not send otp. please try again after sometime.'])
      setErrorMessages([SYSTEM_ERROR])
      setSpinnerLoader(false)
    }
  }, [otpResponse, isCodeGenerated])

  // useEffect(() => {
  //   if (!isAuthorisedUser) {
  //     AppConstants.backToLogin(props);
  //   }
  // }, []);

  const handleChangeRadioButton = (e) => {
    setIsRadioButtonSelected(e.target.value);
  }
  // method to call backend service to send otp
  const sendMFA = () => {
    setErrorMessages([])
    if (!isRadioButtonSelected) {
      setErrorMessages(['Please select appropriate option to send OTP.'])
      return
    }
    const input = {
      'mfaType': (isRadioButtonSelected === 'email' ? 'e' : 's'),
      'userId': userId
      // userId
      // 'PJ1988'
    }
    setSpinnerLoader(true)
    // dispatch(GenerateOtp(input))

    axios.post(`${serviceEndPoint.GENERATE_OTP}`, input)
      .then(response => {
        dispatch(GenerateOtpResponse(response.data));
        setIsCodeGenerated(true)
      })
      .catch(error => {
        dispatch(GenerateOtpResponse({ systemFailure: true }));
        setIsCodeGenerated(false)
      });
  
    
  }
  return (
    <div className="container">
      {spinnerLoader ? <Spinner /> : null}
      <div className="success-alert-container">
        {errorMessages && errorMessages.length > 0 ?
          <ErrorMessages errorMessages={errorMessages} /> : null}
        {/* {successMessages && errorMessages.length === 0 && successMessages.length > 0 ?
          <SuccessMessage successMessages={successMessages} /> : null} */}
      </div>
      <div className="contact-us-block-success font-weight-600">
        <a href="/contactUs" target="_blank">Contact Us</a>
        <span className="blue-font px-1">|</span>
        <a href="/Help" target="_blank">Help</a>
      </div>
      <div className="success-container">
        <div className="">
          <div className="sub-header">Choose how would you like to confirm your account</div>
          <hr />
          {(data.email || data.mobileNumber) ?
            <p className="mui-custom-form">You have confirmed {email_mobile_text}. Please choose below to receive a 6-digit code.</p>
            : null}
            
          {!(data.email || data.mobileNumber) &&  fromPath ?
           <ErrorMessages errorMessages={[EMAIL_MOBILE_ERROR]} />
          : null}
          <div className="mui-custom-form">
          {(data.email || data.mobileNumber) && <FormControl>
            <RadioGroup
              aria-labelledby="radio-button-for-mfa"
              value={isRadioButtonSelected}
              name="radio-buttons-group"
              onChange={handleChangeRadioButton}
            >
              {data.email && <FormControlLabel 
                value="email" 
                control={<Radio />} 
                label={[<EmailIcon />, ' ', data.email]} 
                className="pb-0 m-0"
                />}
              {data.mobileNumber && <FormControlLabel 
                value="sms" 
                control={<Radio />} 
                label={[<SmsIcon />, ' ', data.mobileNumber]} 
                className="pb-0 m-0"
                />}
            </RadioGroup>
          </FormControl>}
          </div>
          <div className="button-wrapper">
            <Button className='btn-primary btn-dialog' onClick={sendMFA} disabled={!(data.email || data.mobileNumber)}>
              Continue </Button>
          </div>
        </div>
      </div>
    </div>

  )
}

export default SendMFACode